module.exports = __webpack_public_path__ + "img/contact.588e0a99.svg";